import { logUtil } from 'packages/src'

/**
 * @param action
 * @param data
 */
export function logEventFacebookPixelUtil (action, data) {
  const logPrefix = `action=${action}`

  logUtil('logEventFacebookPixelUtil').debug(`${logPrefix} data=`, data)

  if (!BROWSER) {
    logUtil('logEventFacebookPixelUtil').debug(`${logPrefix} [noop] not browser`)
    return
  }

  if (!PRODUCTION) {
    logUtil('logEventFacebookPixelUtil').debug(`${logPrefix} [noop] not production`)
    return
  }

  if (!window.fbq) {
    logUtil('logEventFacebookPixelUtil').debug(`${logPrefix} [noop] no fbq`)
    return
  }

  // Default: use track (standard events). If custom, still works.
  try {
    window.fbq('trackCustom', action, data)
    logUtil('logEventFacebookPixelUtil').debug(`${logPrefix} fbq event sent`, data)
  } catch (err) {
    logUtil('logEventFacebookPixelUtil').error(`${logPrefix} fbq error=`, err)
  }
}
